import React, { Component, Fragment } from 'react';
import AttributeSummary from './AttributeSummary';
import XLSX from 'xlsx';
import { getNameForCategory } from '../../utils/incidentHelper';
import originFields from '../../defaults/PointOfOriginFields.json'
import fireCauseConfig from '../../defaults/fireCauseConfig.json'
import { randomColor } from 'randomcolor';
import './SummariesList.css';

class SummariesList extends Component {

  addSum = (total, num) => {
    return total + num;
  }

  getAcresFromIncident = (incident) => 
  {
    return Math.max(incident[originFields.calculatedAcres], incident[originFields.incidentSize]);
  }

  formatCsvData = (data, summary) => {
    let firstRow = [summary, 'Number of Incidents', 'Percentage'];
    let dataRows = [firstRow];
    let totalCount = data.datasets[0].data.reduce(this.addSum);

    for (let i = 0; i < data.labels.length; i++) {
      let newRow = [data.labels[i], data.datasets[0].data[i], parseFloat((data.datasets[0].data[i] / totalCount * 100)).toFixed(2) + " %"];
      dataRows.push(newRow);
    }
    return dataRows;
  }

  downloadCsv = () => {
    const workbook = XLSX.utils.book_new();

    this.props.summaries.forEach(
      summary => {
        let summaryData = this.formatCsvData(this.generateSummaryData(summary), summary);
        let summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
        XLSX.utils.book_append_sheet(workbook, summarySheet, summary);
      });

    XLSX.writeFile(workbook, "summaries.xlsx");
  }

  getColorsForCounts = (counts) => {
    return randomColor({
      count: counts.length
    });
  }

  getFireCauseGeneralData = (fireCauseGeneralIds) => {
    let fireCauseGenerals = [];
    
    fireCauseGeneralIds.forEach( fireCauseGeneralId => {
      const pushValue = (fireCauseGeneralId !== null) ? fireCauseConfig.GeneralFireCauses.find(cause => cause.CauseGeneralID === fireCauseGeneralId).CauseGeneral : "Not Provided";
      fireCauseGenerals.push(pushValue);
    });

    return fireCauseGenerals;
  }


  getFireCauseData = (fireCauseIds) => {
    let fireCauses = [];

    fireCauseIds.forEach(fireCauseId => {
      const pushValue = (fireCauseId !== null) ? fireCauseConfig.FireCauses.find(cause => cause.FireCauseID === fireCauseId).FireCauseName : "Not Provided";
      fireCauses.push(pushValue);
    });

    return fireCauses;
  }

  getDataForPieChart = (labels, counts, acresData) => {
    var notProvided = "Not Provided";

    let modifiedLabels = labels.map(label => {
      return (label === null || label === "" || label === "NULL" || label === undefined) ? notProvided : label;
    });

    //Sort everything
    var combinedList = [];
    for (var j = 0; j < modifiedLabels.length; j++)
      combinedList.push({ 'label': modifiedLabels[j], 'count': counts[j], 'acresData': acresData[j]});

    //2) sort:
    combinedList.sort(function (a, b) {
      return ((a.count > b.count) ? -1 : ((a.count === b.count) ? 0 : 1));
    });

    //3) separate them back out
    for (var k = 0; k < combinedList.length; k++) {
      modifiedLabels[k] = combinedList[k].label;
      counts[k] = combinedList[k].count;
      acresData[k] = combinedList[k].acresData;
    }

    return {
      labels: modifiedLabels,
      datasets: [
        {
          data: counts,
          acres: acresData,
          backgroundColor: this.getColorsForCounts(counts)
        }]
    };
  }

  //TODO: Fix hardcodes
  generateSummaryData = (summaryType) => {
    let chartData;

    switch (summaryType) {
      case "County":
        const distinctCounties = [...new Set(this.props.incidents.map(x => x[originFields.county]))];
        let countyCounts = [];
        let countyAcresData = [];

        for (let i = 0; i < distinctCounties.length; i++) {
          countyCounts.push(this.props.incidents.filter(x => x[originFields.county] === distinctCounties[i]).length);
          const acres = this.props.incidents.filter(x => x[originFields.county] === distinctCounties[i]).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
          countyAcresData.push(acres);
        }

        chartData = this.getDataForPieChart(distinctCounties, countyCounts, countyAcresData);
        break;

      case "Jurisdictional Unit":
        const distinctJurisdictionalUnits = [...new Set(this.props.incidents.map(x => x[originFields.pooJurisdictionalUnit]))];
        chartData = this.getDataForUnits(distinctJurisdictionalUnits, originFields.pooJurisdictionalUnit);
        break;

      case "Protecting Unit":
        const distinctProtectingUnits = [...new Set(this.props.incidents.map(x => x[originFields.pooProtectingUnit]))];
        chartData = this.getDataForUnits(distinctProtectingUnits, originFields.pooProtectingUnit);
        break;

      case "Protecting Agency":
        const distinctProtectingAgencies = [...new Set(this.props.incidents.map(x => x[originFields.pooProtectingAgency]))];
        chartData = this.getDataForUnits(distinctProtectingAgencies, originFields.pooProtectingAgency);

        break;

      case "Landowner Category":
        const distinctLandownerCategories = [...new Set(this.props.incidents.map(x => x[originFields.landownerCategory]))];
        let landownerCategories = [];
        let landownerCategoriesAcresData = [];
        for (let i = 0; i < distinctLandownerCategories.length; i++) {
          landownerCategories.push(this.props.incidents.filter(x => x[originFields.landownerCategory] === distinctLandownerCategories[i]).length);
          const acres = this.props.incidents.filter(x => x[originFields.landownerCategory] === distinctLandownerCategories[i]).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
          landownerCategoriesAcresData.push(acres);
        }

        chartData = this.getDataForPieChart(distinctLandownerCategories, landownerCategories, landownerCategoriesAcresData);
        break;

      case "Fire Cause":
        const distinctFireCauseIds = [...new Set(this.props.incidents.map(x => x[originFields.fireCauseId]))];
        const distinctFireCauses = this.getFireCauseData(distinctFireCauseIds);
        let fireCauses = [];
        let fireCausesAcresData = [];
        for (let i = 0; i < distinctFireCauseIds.length; i++) {
          fireCauses.push(this.props.incidents.filter(x => x[originFields.fireCauseId] === distinctFireCauseIds[i]).length);
          const acres = this.props.incidents.filter(x => x[originFields.fireCauseId] === distinctFireCauseIds[i]).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
          fireCausesAcresData.push(acres);
        }

        chartData = this.getDataForPieChart(distinctFireCauses, fireCauses, fireCausesAcresData);
        break;

      case "Fire Cause General":
        const distinctFireCauseGeneralIds = [...new Set(this.props.incidents.map(x => x[originFields.fireCauseGeneralId]))];
        const distinctFireCauseGenerals = this.getFireCauseGeneralData(distinctFireCauseGeneralIds);
        let fireCauseGenerals = [];
        let fireCauseGeneralsAcresData = [];
        for (let i = 0; i < distinctFireCauseGeneralIds.length; i++) {
          fireCauseGenerals.push(this.props.incidents.filter(x => x[originFields.fireCauseGeneralId] === distinctFireCauseGeneralIds[i]).length);
          const acres = this.props.incidents.filter(x => x[originFields.fireCauseGeneralId] === distinctFireCauseGeneralIds[i]).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
          fireCauseGeneralsAcresData.push(acres);
        }

        chartData = this.getDataForPieChart(distinctFireCauseGenerals, fireCauseGenerals, fireCauseGeneralsAcresData);
        break;

      case "Size Class":
        const sizeClassLabels = ["Class A", "Class B", "Class C", "Class D", "Class E", "Class F", "Class G"];
        const sizeClassData = this.getSizeClassesForSummaries();
        const sizeClassAcresData = this.getSizeClassAcreage();  

        chartData = this.getDataForPieChart(sizeClassLabels, sizeClassData, sizeClassAcresData);

        break;

      case "Incident Category":
        const distinctCategories = [...new Set(this.props.incidents.map(x => x["IncidentTypeCategory"]))];
        const distinctCategoriesByName = [];
        for (let i = 0; i < distinctCategories.length; i++) {
          distinctCategoriesByName.push(getNameForCategory(distinctCategories[i]));
        }

        let categoryCounts = [];
        let categoryCountsAcresData = [];
        for (let i = 0; i < distinctCategories.length; i++) {
          categoryCounts.push(this.props.incidents.filter(x => x["IncidentTypeCategory"] === distinctCategories[i]).length);
          const acres = this.props.incidents.filter(x => x["IncidentTypeCategory"] === distinctCategories[i]).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
          categoryCountsAcresData.push(acres);
        }
        chartData = this.getDataForPieChart(distinctCategoriesByName, categoryCounts, categoryCountsAcresData);
        break;

      case "State":
        const distinctStates = [...new Set(this.props.incidents.map(x => x["POOState"]))];
        let stateCounts = [];
        let stateCountsAcresData = [];
        for (let i = 0; i < distinctStates.length; i++) {
          stateCounts.push(this.props.incidents.filter(x => x["POOState"] === distinctStates[i]).length);
          const acres = this.props.incidents.filter(x => x["POOState"] === distinctStates[i]).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
          stateCountsAcresData.push(acres);
        }
        chartData = this.getDataForPieChart(distinctStates, stateCounts, stateCountsAcresData);
        break;


      case "Jurisdictional Agency":
        const distinctJurisdictionalAgencies = [...new Set(this.props.incidents.map(x => x["POOJurisdictionalAgency"]))];
        let jurisdictionalAgencies = [];
        let jurisdictionalAgenciesAcresData = [];
        for (let i = 0; i < distinctJurisdictionalAgencies.length; i++) {
          jurisdictionalAgencies.push(this.props.incidents.filter(x => x["POOJurisdictionalAgency"] === distinctJurisdictionalAgencies[i]).length);
          const acres = this.props.incidents.filter(x => x["POOJurisdictionalAgency"] === distinctJurisdictionalAgencies[i]).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
          jurisdictionalAgenciesAcresData.push(acres);
        }

        chartData = this.getDataForPieChart(distinctJurisdictionalAgencies, jurisdictionalAgencies, jurisdictionalAgenciesAcresData);
        break;

      default:
        console.log("generateSummaryData: Nothing matched for " + summaryType);
    }

    return chartData;
  }

  getDataForUnits = (distinctValues, attributeName) => 
  {
    let valuesArray = [];
    let acresData = [];
    const nonEmptyValues = distinctValues.filter(x => x !== "" && x !== null && x !== undefined).map(x => x.toUpperCase().trim());
    const emptyValues = distinctValues.filter(x => x === "" || x === null || x === undefined);

    for (let i = 0; i < nonEmptyValues.length; i++) 
    {
      valuesArray.push(this.props.incidents.filter(x => x[attributeName] !== null && x[attributeName].toUpperCase().trim().localeCompare(nonEmptyValues[i]) === 0).length);
      try 
      {
          const acres = this.props.incidents.filter(x => x[attributeName] !== null && x[attributeName].toUpperCase().trim().localeCompare(nonEmptyValues[i]) ===0).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
          acresData.push(acres);
        } 
        catch (e) 
        {
          acresData.push(0);
        }   
    }

    if (emptyValues.length > 0) 
    {
      const incidentsWithMissingStuff = this.props.incidents.filter(x => x[attributeName] === "" || x[attributeName] === null || x[attributeName] === undefined);
      if (incidentsWithMissingStuff.length > 0)  
      {
        valuesArray.push(incidentsWithMissingStuff.length);
        const acres = incidentsWithMissingStuff.map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
        acresData.push(acres);

        nonEmptyValues.push("NULL");
      }
    }

    return this.getDataForPieChart(nonEmptyValues, valuesArray, acresData);
  }

  generateSelectedSummaries = () => {
    let shouldRender = (this.props.summaries && this.props.summaries.length > 0 &&
      this.props.incidents && this.props.incidents.length > 0);

    if (!shouldRender) {
      return <div></div>;
    }

    return this.props.summaries.forEach(summaryType => {
      let chartData = this.generateSummaryData(summaryType);
      (
        <div className="report-page">
          <AttributeSummary
            chartData={chartData}
            label={summaryType}
            key={summaryType}
          />
        </div>)
    }
    )
  }

  getSizeClassesForSummaries = () => {
    let classA = this.props.incidents.filter(x => this.getAcresFromIncident(x) <= 0.25).length;
    let classB = this.props.incidents.filter(x => (0.25 < this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 10)).length;
    let classC = this.props.incidents.filter(x => (10 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 100)).length;
    let classD = this.props.incidents.filter(x => (100 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 300)).length;
    let classE = this.props.incidents.filter(x => (300 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 1000)).length;
    let classF = this.props.incidents.filter(x => (1000 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 5000)).length;
    let classG = this.props.incidents.filter(x => this.getAcresFromIncident(x) > 5000).length;

    return [classA, classB, classC, classD, classE, classF, classG];
  }

  //TODO: Junk, refactor
  getSizeClassAcreage = () => {
    //let acresClassA = this.props.incidents.filter(x => this.getAcresFromIncident(x) <= 0.25).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
    const classAAcres = this.props.incidents.filter(x => this.getAcresFromIncident(x) <= 0.25);
    const acresClassA = (classAAcres && classAAcres.length > 0) ? classAAcres.map(x => this.getAcresFromIncident(x)).reduce(this.addSum) : 0;
    
    //let acresClassB = this.props.incidents.filter(x => (0.25 < this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 10)).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
    const classBAcres = this.props.incidents.filter(x => (0.25 < this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 10));
    const acresClassB = (classBAcres && classBAcres.length > 0) ? classBAcres.map(x => this.getAcresFromIncident(x)).reduce(this.addSum) : 0;
    
    //let acresClassC = this.props.incidents.filter(x => (10 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 100)).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
    const classCAcres = this.props.incidents.filter(x => (10 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 100));
    const acresClassC = (classCAcres && classCAcres.length > 0) ? classCAcres.map(x => this.getAcresFromIncident(x)).reduce(this.addSum) : 0;
    
    //let acresClassD = this.props.incidents.filter(x => (100 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 300)).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
    const classDAcres = this.props.incidents.filter(x => (100 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 300));
    const acresClassD = (classDAcres && classDAcres.length > 0) ? classDAcres.map(x => this.getAcresFromIncident(x)).reduce(this.addSum) : 0;
    
    //let acresClassE = this.props.incidents.filter(x => (300 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 1000)).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
    const classEAcres = this.props.incidents.filter(x => (300 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 1000));
    const acresClassE = (classEAcres && classEAcres.length > 0) ? classEAcres.map(x => this.getAcresFromIncident(x)).reduce(this.addSum) : 0;

    //let acresClassF = this.props.incidents.filter(x => (1000 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 5000)).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
    const classFAcres = this.props.incidents.filter(x => (1000 <= this.getAcresFromIncident(x)) && (this.getAcresFromIncident(x) < 5000));
    const acresClassF = (classFAcres && classFAcres.length > 0) ? classFAcres.map(x => this.getAcresFromIncident(x)).reduce(this.addSum) : 0;
   
    //let acresClassG = this.props.incidents.filter(x => this.getAcresFromIncident(x) > 5000).map(x => this.getAcresFromIncident(x)).reduce(this.addSum);
    const classGAcres = this.props.incidents.filter(x => this.getAcresFromIncident(x) > 5000);
    const acresClassG = (classGAcres && classGAcres.length > 0) ? classGAcres.map(x => this.getAcresFromIncident(x)).reduce(this.addSum) : 0;

    return [acresClassA, acresClassB, acresClassC, acresClassD, acresClassE, acresClassF, acresClassG];
  }

  render() {
    let shouldRender = (this.props.summaries.length > 0 &&
      this.props.incidents.length > 0);

    if (!shouldRender) {
      return <div></div>;
    }
    else {
      const summaryData = this.props.summaries.map(summaryType => {
        let chartData = this.generateSummaryData(summaryType);
        return <div className="report-page">
          <AttributeSummary
            chartData={chartData}
            label={summaryType}
            key={summaryType}
          />
        </div>
      }
      );
      return (
        <Fragment>
          {summaryData}
          <div className="report-page">
            <p style={{ fontWeight: "bold" }}>Filter: {this.props.definitionExpression}</p>
          </div>
          <div className="summaries-report-page-map">
            <img style={{ marginLeft: "auto", marginRight: "auto", display: "block" }} alt="Screenshot" src={this.props.screenshot.dataUrl} />
          </div>
        </Fragment>
      )
    }
  }
}
export default SummariesList
